import { render, staticRenderFns } from "./cjAct2.vue?vue&type=template&id=63ce4722&scoped=true"
import script from "./cjAct2.vue?vue&type=script&lang=js"
export * from "./cjAct2.vue?vue&type=script&lang=js"
import style0 from "./cjAct2.vue?vue&type=style&index=0&id=63ce4722&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ce4722",
  null
  
)

export default component.exports